import React, { Component } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import DatePanel from "../side-bar/DatePanel";
import SideBarTemplate from "../side-bar/SideBarTemplate";
import BulletinPanel from "../BulletinPanel/BulletinPanel";
import LightModePageTemplate from "../page/Templates/LightModeTemplate";
//import BillingFormUtils, { BillingFormData, BillingStatus } from "../Billing/BillingFormUtils";
import PaymentPrepareComponent from "./PaymentPrepareComponent";
// import { NullableDate } from "../grid/AddEditPopUpUtilities";
// import { AxiosResponse } from "axios";
// import lookupService, { LookupTypeIndexes, LookupTypeItem } from "../../services/LookupService";
// import { billingCycleStatus } from "../../services/BillingService";
// import sharedUtils from "../grid/sharedUtilities";
import paymentFormUtils, { PaymentFormData } from "../Payments/PaymentFormUtils";
import { paymentStatus } from "../../services/PaymentService";
import PaymentsAndChecksComponent from "./PaymentsAndChecksComponent";

interface PaymentPagePreviewProps extends RouteComponentProps {
    title: string;
    category: string;
    location: any;
}

export interface LookUpTypeItemForServiceType {
    serviceTypeLookupId: number;
    value: string;
    parentMappingId: string;
}

interface PaymentPagePreviewState {
    paymentStatus: string;
    isClickedRestart: boolean;
    isRestartDisable: boolean;
    paymentCycleId: number;
    calculationsObject: {
        subTotal: string;
        total: string;
        tax: string;
    };
    paymentData: PaymentFormData;
    isClickedLockedShift: boolean;
    isShowIncludedPayments: boolean;
    isPrepareDisable: boolean;
    status: string;
    isPrepareClicked: boolean;
    isSuccessRestart: boolean;
    loadPanelVisible: boolean;
    clickedOnButton: string;
    statusId: string;
    refreshPage: boolean;
    isShowDocumentSection: boolean;
    isShowPaymentSendSection: boolean;
    isShowInvoiceSection: boolean;
    isShowPaymentPaid: boolean;
    isShowPaymentRemittance: boolean;
    showPreviewGrid:boolean;
    isPreviewClicked: boolean;
    isError: boolean;
    error: [];
}

class PaymentPagePreview extends Component<PaymentPagePreviewProps> {
    //Initialize the component's state.
    state: PaymentPagePreviewState;
    utils: paymentFormUtils;
    constructor(props: PaymentPagePreviewProps) {
        super(props);
        this.utils = new paymentFormUtils();
        var convertedEditPaymentData = this.utils.initializePaymentItems("");
        this.state = {
            paymentStatus: paymentStatus.Draft,
            isClickedRestart: false,
            isRestartDisable: false,
            paymentCycleId: 0,
            calculationsObject: {
                subTotal: "",
                total: "",
                tax: "",
            },
            paymentData: convertedEditPaymentData,
            isClickedLockedShift: false,
            isShowIncludedPayments: false,
            isPrepareDisable: false,
            status: paymentStatus.Draft,
            isPrepareClicked: false,
            isSuccessRestart: false,
            loadPanelVisible: false,
            clickedOnButton: "",
            statusId: paymentStatus.Draft,
            refreshPage: false,
            isShowDocumentSection: false,
            isShowPaymentSendSection: false,
            isShowInvoiceSection: false,
            isShowPaymentPaid: false,
            isShowPaymentRemittance: false,
            showPreviewGrid:false,
            isPreviewClicked: false,
            isError: false,
            error: [],
        };
    }

    componentDidMount() {
        //this.vatConfig();
    }

    onReceiveData = (
        paymentCycleId: string,
        formData: PaymentFormData,
        status: string,
        isRestartDisable: boolean,
        isShowIncludedPayments: boolean,
        isSuccessRestart: boolean,
        statusId: string,
        showPreviewGrid?: boolean,
        isPreviewClicked?:boolean
    ) => {
        this.setState((prevState: PaymentPagePreviewState) => ({
            paymentCycleId: paymentCycleId,
            paymentData: formData,
            isShowIncludedPayments: isShowIncludedPayments,
            status: status,
            paymentStatus: status,
            statusId: statusId ? statusId : formData.statusId,
            isSuccessRestart: isSuccessRestart ? !prevState.isSuccessRestart : prevState.isSuccessRestart,
            isPrepareClicked: isSuccessRestart ? prevState.isPrepareClicked : !prevState.isPrepareClicked,
            isRestartDisable: isRestartDisable,
            showPreviewGrid:showPreviewGrid,
            isPreviewClicked:isPreviewClicked,
            refreshPage:!this.state.refreshPage
        }));
    };

     // A function which is invoked when the "Save" button is clicked on the Summary panel.
     onSavePaymentData = (paymentCycleId: string, formData: PaymentFormData) => {
        this.setState({
            paymentCycleId: paymentCycleId,
            paymentData: formData,
            statusId: formData.statusId,
            isRestartDisable:
                formData.statusId == paymentStatus.PaymentAdvised ||
                paymentStatus.PaymentSettled ||
                paymentStatus.PaymentRemittanceRequested ||
                paymentStatus.PaymentRemitted
                    ? true
                    : false,
        });
    };

    setCalculationsCallback = (calculationsObject: any) => {
        if (calculationsObject.total || calculationsObject.subTotal || calculationsObject.tax) {
            this.setState({
                calculationsObject: {
                    ...this.state.calculationsObject,
                    total: calculationsObject.total,
                    subTotal: calculationsObject.subTotal,
                    tax: calculationsObject.tax,
                },
            });
        }
    };
    previewUpdate = (flag1: boolean, flag2: boolean, error: []) => {
        this.setState({
            isPreviewClicked:flag1, 
            isError:flag2,
            error: error
        });
    }


    render() {
        return (
            <LightModePageTemplate>
                <SideBarTemplate isFixed={true}>
                    <DatePanel />
                    <BulletinPanel />
                </SideBarTemplate>
                <section className="page-content--with-sidebar-hidden-mobile">
                    <header className="grid-info mb-3">
                        <h2>
                            <b>Payments - Preview</b>
                        </h2>
                    </header>

                    <PaymentPrepareComponent
                            isClickedLockedShift={false}
                            location={this.props.location}
                            onReceiveData={this.onReceiveData}
                            savePaymentData={this.onSavePaymentData}
                            calculationsObject={this.state.calculationsObject}
                            isClickedRestart={this.state.isClickedRestart}
                            status={this.state.status}
                            clickedOnButton={this.state.clickedOnButton}
                            statusId={this.state.statusId}
                            refreshPage={this.state.refreshPage}
                            history={this.props.history}
                            pageType="PaymentsPreview"
                            isError={this.state.isError}
                            error={this.state.error}
                        />
                        {this.state.isShowIncludedPayments && this.state.showPreviewGrid ? (
                            <PaymentsAndChecksComponent
                                viewDisabled={false}
                                paymentCycleId={this.state.paymentCycleId.toString()}
                                paymentData={this.state.paymentData}
                                // onClickPaymentsStatus={this.onClickPaymentsStatus}
                                onClickPaymentsStatus={()=>{}}
                                statusId={this.state.statusId}
                                isClickedRestart={false}
                                isPrepareClicked={false}
                                isSuccessRestart={false}
                                calculationObject={this.state.calculationsObject}
                                setCalculationsCallback={this.setCalculationsCallback}
                                refreshPage={this.state.refreshPage}
                                isPreviewClicked={this.state.isPreviewClicked}
                                pageType="PaymentsPreview"
                                previewUpdate={this.previewUpdate}
                            />
                        ) : null}
                    {/* <BillingPrepareComponent
                        isClickedLockedShift={false}
                        location={this.props.location}
                        onReceiveData={this.onReceiveData}
                        saveBillingData={this.onSaveBillingData}
                        calculationsObject={this.state.calculationsObject}
                        isClickedRestart={false}
                        status={this.state.status}
                        statusId={this.state.statusId}
                        syncDateFields={this.syncDateFields}
                        syncAmountFields={this.syncAmountFields}
                        invoiceSentDate={this.state.invoiceSentDate}
                        invoicePaidDate={this.state.invoicePaidDate}
                        invoiceAmount={this.state.invoiceAmount}
                        refreshPage={false}
                        vatConfig={this.state.vatConfig}
                        pageType="BillingPreview"
                        previousPage={this.props.history}
                        isError={this.state.isError}
                        error={this.state.error}

                    />
                    {this.state.isShowIncludedShift && this.state.previewGrid ? (
                        <LockShiftComponent
                            viewDisable={false}
                            invoiceId={this.state.invoiceId}
                            billingData={this.state.billingPreviewData}
                            setCalculationsCallback={this.setCalculationsCallback}
                            onClickLockedShift={()=>{}}
                            isPrepareClicked={false}
                            isSuccessRestart={false}
                            statusId={this.state.statusId}
                            gridType="BillingPreview"
                            isPreviewClicked={this.state.isPreviewClicked}
                            previewUpdate={this.previewUpdate}
                        />
                    ) : (
                        <></>
                    )}
                    {this.state.isShowIncludedShift && this.state.previewGrid ? (                        
                        <ReportsGridComponent
                            viewDisable={false}
                            invoiceId={this.state.invoiceId}
                            previewGrid={this.state.previewGrid}
                            billingData={this.state.billingPreviewData}
                            onShiftsChecked={() => { return null }}
                            setTaxValues={this.setCalculationsCallback}
                            statusId={this.state.statusId}
                            calculationsObject={this.state.calculationsObject}
                            isPreviewClicked={this.state.isPreviewClicked}
                        />
                    ) : (
                        <></>
                    )} */}
                </section>
            </LightModePageTemplate>
        );
    }
}

export default withRouter(PaymentPagePreview);
